import { SlickError } from 'errors/Slick.error';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import { nowAsIso } from 'utils/date/now.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

export class FeStack extends SlickError {
  // NOTE: don't use it as a regular error to be thrown, just as an object that has stack trace information
  constructor(options) {
    super({
      ...options,
      tag: fromAnyToTrimmed(options?.tag) || '**untagged**',
      now: isDateWorthy(options?.now) ? fromAnyDateToIso(options?.now) : nowAsIso(),
      name: 'Not an error, just a stack trace collector',
    });
  }
}

// noinspection JSUnusedGlobalSymbols
export class FeOption extends SlickError {
  constructor(options) {
    const { tag, now, ...extra } = options ?? {};

    const strings = fromObjectToEntries(extra ?? {}).map(([k, v]) => `invalid option ${k}: ${v}`);

    super({
      ...options,
      tag: fromAnyToTrimmed(tag) || '**untagged**',
      now: isDateWorthy(now) ? fromAnyDateToIso(now) : nowAsIso(),
      name: `FeOption: ${strings.join(', ')}.`,
    });
  }
}
